import { render, staticRenderFns } from "./SettingsLookups.vue?vue&type=template&id=26952ff5"
import script from "./SettingsLookups.vue?vue&type=script&lang=js"
export * from "./SettingsLookups.vue?vue&type=script&lang=js"
import style0 from "./SettingsLookups.vue?vue&type=style&index=0&id=26952ff5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports